import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "@redq/reuse-modal";
import Checkout from "../containers/CheckoutWithSidebar/CheckoutWithSidebar";
import { useDeviceType } from "../helper/useDeviceType";
import { ProfileProvider } from "../contexts/profile/profile.provider";
import { connect } from "react-redux";
import t from "../i18n/translate"
import {
  addAddress,
  getAddress,
  updateAddress,
  deleteAddress,
  alldeliverySlots,
  slotsForDate,
  allCouponCodes,
  moveToCheckout,
  makePayment,
} from "../store/actions/userAction";
import {
  placeOrder,
  fetchCart,
  expressCheckout,
  changeOrderStatus, initBasket, initWallet, initDelipoints
} from "../store/actions/cartAction";
import { useCart } from "../contexts/cart/use-cart";
import * as Constant from '../constants/Constant';
import axios from 'axios';

const CheckoutPage = (props, { userAgent }) => {
  const deviceType = useDeviceType(userAgent);
  const token = "true";
  const { itemsCount } = useCart();
  const orderId = localStorage.getItem("order_id");
  const history = useHistory();

  // useEffect(() => {
  //   if (orderId === "0" || orderId === 0 || orderId === "undefined") {
  //     history.push("/");
  //     localStorage.setItem("order_id", 0);
  //   };
  // }, []);

  useEffect(() => {
    sessionStorage.setItem("pageSource","/checkout")
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        if (orderId === "0" || orderId === 0 || orderId === "undefined") {
          history.push("/");
          localStorage.setItem("order_id", 0);
        };
        setTimeout(function () {
          window.location.reload();
        }, 10);
      } else {
        if (orderId === "0" || orderId === 0 || orderId === "undefined") {
          history.push("/");
          localStorage.setItem("order_id", 0);
        };
      }
    }, false);
    window.scrollTo({
      top: 0,
      behavior:"auto"
    });
  }, []);
    
  // useMemo(() => {
  //   if (!window.location.hash) return;
    
  //   let reload = setTimeout(() => {
  //     history.replace("/checkout", null, null);
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //   }, 1000);
    
  //   return () => clearTimeout(reload);
    
  // }, [window.location.hash]);
      
  //Update wallet and delipoints balance in the store if not already updated
  useEffect(async () => {
    if (props.wallet === null || props.delipoints === null) {
      const walletAPI = Constant.baseUrl + 'v1/wallet/get/current/amount';
      const delipointsAPI = Constant.baseUrl + 'api/v1/delipoints/customer/current';
      const token = localStorage.getItem('token');
      const walletResp = await axios.get(walletAPI, { headers: { Authorization: token } });
      const delipointsResp = await axios.get(delipointsAPI, { headers: { Authorization: token } });

      if (walletResp.status === 200) {
        props.initWallet(walletResp.data);
      }
      if (delipointsResp.status === 200) {
        props.initDelipoints(delipointsResp.data);
      }
    }
  }, [props.wallet])

  return (
    <>
        <ProfileProvider initData={""}>
          <Modal>
            <Checkout token={token} deviceType={deviceType} props={props} />
          </Modal>
        </ProfileProvider>
    </>
  );
};
CheckoutPage.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};
const mapStateToProps = (state) => {
  return {
    orderPlaced: state.cartReducer.orderPlaced,
    modalData: state.productReducer.modalData,
    user_address: state.userReducer.address,
    deliveryCharge: state.userReducer.deliveryCharge,
    distanceBetweenUserStore: state.userReducer.distanceBetweenUserStore,
    delivery_slots: state.userReducer.delivery_slots,
    slots_for_date: state.userReducer.slots_for_date,
    all_slots: state.userReducer.all_slots,
    all_timings: state.userReducer.all_timings,
    calendar_response: state.userReducer.calendar_response,
    all_coupon_codes: state.userReducer.all_coupon_codes,
    cartData: state.cartReducer.cartData,
    checkoutdata: state.userReducer.checkoutdata,
    paymentResponse: state.userReducer.paymentResponse,
    wallet: state.cartReducer.wallet,
    delipoints: state.cartReducer.delipoints,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAddress: (body) => addAddress(body, dispatch),
    updateAddress: (body) => updateAddress(body, dispatch),
    deleteAddress: (body) => deleteAddress(body, dispatch),
    getAddress: () => getAddress(dispatch),
    alldeliverySlots: (body) => alldeliverySlots(body, dispatch),
    slotsForDate: (body) => slotsForDate(body, dispatch),
    placeOrder: (body) => placeOrder(body, dispatch),
    changeOrderStatus: () => changeOrderStatus(dispatch),
    allCouponCodes: (body) => allCouponCodes(body, dispatch),
    fetchCart: (body) => fetchCart(body, dispatch),
    moveToCheckout: (body) => moveToCheckout(body, dispatch),
    makePayment: (body) => makePayment(body, dispatch),
    initBasket: (body) => initBasket(body, dispatch),
    expressCheckout: (body) => expressCheckout(body, dispatch),
    initWallet: (data) => initWallet(data, dispatch),
    initDelipoints: (data) => initDelipoints(data, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPage);
